export interface ClientPasswordRules {
  minLength: boolean;
  hasUpper: boolean;
  hasDigit: boolean;
  hasSpecial: boolean;
  score: number;
}

export function evaluatePasswordRules(password: string): ClientPasswordRules {
  const minLength = !!password && password.length >= 10;
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);

  const passedCount = [minLength, hasUpper, hasDigit, hasSpecial].filter(Boolean).length;

  return {
    minLength,
    hasUpper,
    hasDigit,
    hasSpecial,
    score: passedCount
  };
}
